import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";

export default function AdStrip() {
  return (
    <Link
      to="/consulting"
      className="block bg-[#d9f99d] text-[#0b1020] border-b border-[#0b1020]/20 hover:bg-[#c5f167] transition-colors"
      data-testid="ad-strip"
    >
      <Marquee speed={55} gradient={false} pauseOnHover>
        <div className="flex items-center gap-6 py-2.5 px-6 text-[12.5px] font-semibold">
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={`ad-item-${i}`} className="flex items-center gap-3" data-testid={`ad-strip-item-${i}`}>
              <Megaphone className="w-3.5 h-3.5" strokeWidth={2.5} />
              Advertise your company here
              <span className="text-[#f43f5e]">·</span>
              Contact us for details
              <ArrowRight className="w-3.5 h-3.5" />
              <span className="text-[#0b1020]/30 mx-4">|</span>
            </span>
          ))}
        </div>
      </Marquee>
    </Link>
  );
}
